import { reduxForm, SubmissionError, reset } from 'redux-form'
import { connect } from 'react-redux'
import moment from 'moment'
import flowRight from 'lodash/flowRight'
import keys from 'lodash/keys'
import { translate } from 'loankeeper-common/helpers'

import { FORM_NAME } from '../constants'
import { forgetOTP, getPersistedOTP } from '../../../store/persist'
import { login } from '../../../store/auth'
import { validateBuildVersion } from './login.actions'
import { AppDispatch } from 'src/store/index.d'

const isProduction = process.env.NODE_ENV === 'production'

const tranlateMain = (key: string): string => translate(`frm_web_messages-${key}`)

const validate = (values: { username: string; password: string; otp: string }) => {
  const errors: {
    password?: string
    username?: string
  } = {}

  const regularExpression = /^[ A-Za-z0-9_@./#&+-<>?=()*^%$!`~|/[\]\\{},.;:'"]*$/.test(values.password)

  if (!regularExpression) {
    errors.password = tranlateMain('ERR_INVALID_PASSWORD_FORMAT')
  }

  if (!values.username) {
    errors.username = tranlateMain('ERR_INVALID_USER_PASS')
  }

  if (!values.password) {
    errors.password = tranlateMain('ERR_INVALID_USER_PASS')
  }

  return errors
}

// OTPHash
// OTPHashExpire
function validateOTP(username: string, otp: string, OTPInfo) {
  const { hash, expire } = OTPInfo[username] || {}

  if ((!hash || moment(expire).isBefore(moment())) && !otp) {
    throw new SubmissionError({
      otp: 'otp required',
    })
  }
}

const container = reduxForm({
  form: FORM_NAME,
  touchOnChange: true,
  validate,

  async onSubmit(
    {
      username,
      password,
      otp,
    }: {
      username: string
      password: string
      otp: string
    },
    dispatch: AppDispatch,
    {
      OTPInfo,
    }: {
      OTPInfo: {
        [key: string]: {
          expire: number
          hash: string
        }
      }
    },
  ) {
    if (isProduction) {
      const validationResult = await dispatch(validateBuildVersion())
      if (validateBuildVersion.rejected.match(validationResult)) {
        return
      }
    }

    const user = username.toLowerCase() // to avoid case sensitivity. when it is stored it is converted in lower case.

    validateOTP(user, otp, OTPInfo)

    const now = moment()

    // Check all other user's OTP if invalid delete key from local storage (105t)
    const removeOTPKeys = keys(OTPInfo).filter((key) => !moment(OTPInfo[key].expire).isSameOrAfter(now))

    if (removeOTPKeys.length > 0) {
      dispatch(forgetOTP(removeOTPKeys))
    }

    const config: {
      username: string
      password: string
      otphash?: string
      otp?: string
    } = {
      username: user,
      password,
    }

    if (removeOTPKeys.indexOf(user) === -1 && OTPInfo[user] && OTPInfo[user].hash) {
      config.otphash = OTPInfo[user].hash
    } else {
      config.otp = otp
    }

    const loginResultAction = await dispatch(
      login({
        username: user,
        password,
        otp: config?.otp?.replace(/\s/g, ''),
        otpHash: config.otphash,
      }),
    )

    //@ts-ignore
    if (login.rejected.match(loginResultAction) && loginResultAction.payload?.formErrors) {
      //@ts-ignore
      throw new SubmissionError(loginResultAction.payload.formErrors)
    }
  },
})

export default flowRight(
  connect(
    (state) => ({
      OTPInfo: getPersistedOTP(state),
    }),
    (dispatch) => ({
      resetFormValues: () => dispatch(reset(FORM_NAME)),
    }),
  ),
  container,
)
